import React from "react";
import "../../App.css";
import Info from "../Info";

function Services() {
  return (
    <>
      <div className="services"></div>
      <Info />
    </>
  );
}

export default Services;
